import { requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'

export const lookup = (username) => {
  return apiClient.get(null, `auth/lookup?email=${encodeURIComponent(username)}`)
}

export const loginSSO = async (authorizationCode, codeVerifier) => {
  return await requestWithPromise('/auth/login-sso', HttpMethods.POST, { code: authorizationCode, codeVerifier: codeVerifier })
}
